import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function ProtectedRoute({ children }) {
    const { user } = useAuth();
    const location = useLocation();

    if (user === null) {
        return (
            <div className="min-h-screen grid place-items-center bg-background text-muted-foreground font-mono-ui text-sm">
                Verifying session…
            </div>
        );
    }
    if (user === false) {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }
    return children;
}
